import styled from 'styled-components/macro';
import { ReactComponent as returnIcon } from '../../../../../assets/icons/return.svg';

export const StyledInputWrapper = styled.div.attrs({
  className: 'meter-input-wrapper',
})<{ isReadingsChanged: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;

  & input {
    font-weight: ${(props) => (props.isReadingsChanged ? '600' : '400')};
    color: ${(props) => (props.isReadingsChanged ? '#1F2939' : '#9DA6B4')};
  }
`;

export const ResetBadge = styled.div<{ isShow: boolean }>`
  padding: 3px;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(100%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform-origin: top right;
  scale: ${(props) => (props.isShow ? '1' : '0')};
  transition: scale 0.2s ease;
  overflow: hidden;

  &:hover svg {
    path {
      fill: #1d4ed6;
    }
  }
`;

export const ReturnIcon = styled(returnIcon)`
  width: 16px;
  height: 16px;
`;
